import { Toaster as Sonner, ToasterProps, toast } from 'sonner';
import { CheckIcon, XIcon } from '@page/icons';

import { Loader } from '../Loader';

const Toaster = ({ ...rest }: Omit<ToasterProps, 'theme'>) => {
  return (
    <Sonner
      theme="light"
      className="toaster group z-601! pointer-events-auto"
      style={
        {
          '--normal-bg': 'var(--color-bg-sur-primary)',
          '--normal-text': 'var(--color-text-primary)',
          '--normal-border': 'var(--color-border-default)',
          '--border-radius': '16px',
          '--width': '400px',
          '--success-bg': 'var(--color-bg-sur-primary)',
          '--success-text': 'var(--color-text-success)',
          '--success-border': 'var(--color-border-default)',
          '--error-bg': 'var(--color-bg-sur-primary)',
          '--error-text': 'var(--color-text-destructive)',
          '--error-border': 'var(--color-border-default)',
          '--info-bg': 'var(--color-bg-sur-primary)',
          '--info-text': 'var(--color-text-primary)',
          '--info-border': 'var(--color-border-default)',
          '--warning-bg': 'var(--color-bg-sur-primary)',
          '--warning-text': 'var(--color-text-warning)',
          '--warning-border': 'var(--color-border-default)',
        } as React.CSSProperties
      }
      richColors
      toastOptions={{
        classNames: {
          toast: 'min-w-[400px] w-fit!',
          icon: 'self-start size-5!',
          title: 'font-body-md font-semibold!',
          description: 'font-body-sm text-text-primary!',
        },
      }}
      icons={{
        loading: <Loader variant="thick" className="size-5" />,
        success: <CheckIcon className="size-5 fill-icon-success stroke-1.5" />,
        error: <XIcon className="size-5 fill-icon-error" />,
      }}
      {...rest}
    />
  );
};

export { Toaster, toast };
